import { fetcher } from '@commenda/utils';

import { LocationType } from '@prisma/client';
import { TAddressParams } from '../business-entity';

type FilePayload = {
  fileName: string;
  fileUrl: string;
  documentType: string;
};

export type TUpdateKeyPersonParams = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  locations?: {
    locationTypes: LocationType[];
    address: TAddressParams;
  }[];
  governmentId?: FilePayload;
  panCard?: FilePayload;
  aadharCard?: FilePayload;
  addressProof?: FilePayload;
  dscProof?: FilePayload;
  bankTransferProof?: FilePayload;
  directorIdentificationNumber?: string;
};

export const updateKeyPerson = async (
  personId: number,
  body: TUpdateKeyPersonParams
) => {
  const res = await fetcher(`persons/${personId}`, {
    method: 'POST',
    body,
  });

  return res;
};
